module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        showColorBar: true,
        tabConfigNavKey: 'contractors',
    },

    methods: {
        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            tabOptions.title        = entityAttributes.companyName || ''
            tabOptions.titleSuffix  = ` [${entityID}]`

            return tabOptions
        },
    },

    // hooks: {
    //     attach: function($element, options){
    //         if(!options.refresh){
    //             setTimeout(() => {
    //                 this.find('templates_office_contractors_table', table => {
    //                     let nrOfElements = 0
    //                     const elements = table.$.find('tbody > tr')
    //                     for(const e in elements){
    //                         if(typeof elements[e].click === 'function'){
    //                             elements[e].click()
    //                             nrOfElements++;
    //                             if(nrOfElements >= 1){
    //                                 break
    //                             }
    //                         }
    //                     }
    //                 })
    //             }, 50)
    //         }
    //     }
    // }
}